const historyAdvance = {
	data() {
		return {
			advanceTable: []
		}
	},
	mounted() {
		this.getAdvanticeList()
	},
	methods: {
		getAdvanticeList() {
			this.$post('/reportApi/queryExamProgressiveRank', this.params).then(res => {
				this.advanceTable = res.data
				res.data.forEach(resp => {
					let max = 0,
						maxName = '',
						min = 0,
						minName = '',
						schoolName = ""
					resp.classInfoDTO.forEach(ele => {
						schoolName = ele.examInfoDTOS[0].examName
						if (ele.progressiveRank >= max) {
							max = ele.progressiveRank
							maxName = ele.className
						}
						if (ele.progressiveRank <= min) {
							min = ele.progressiveRank
							minName = ele.className
						}
					})
					resp.max = max
					resp.maxName = maxName
					resp.min = min
					resp.minName = minName
					resp.schoolName = schoolName
				})

				console.log(res.data);
			})
		}
	}
}
export default historyAdvance
